import * as React from 'react';

const SvgFieldChecked = (props) => (
  <svg
    width={14}
    height={14}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.003 13.666a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333Zm2.754-7.828a.5.5 0 1 0-.768-.64L7.392 7.115c-.327.391-.538.643-.716.803-.167.151-.235.156-.266.156-.031 0-.1-.005-.267-.156-.177-.16-.388-.412-.715-.803l-.412-.495a.5.5 0 1 0-.768.64l.435.522c.297.357.553.665.79.878.253.23.552.414.937.414s.683-.185.937-.414c.237-.213.493-.521.79-.878l1.62-1.944Z'
      fill='#4EB175'
    />
  </svg>
);

export default SvgFieldChecked;
